import type { ReactNode } from 'react';
import type { RowDataAttributes } from './DetailList';
import styles from './Fact.module.css';

/**
 * 🔒 One fact in a facts list (piece 4; T2162, extending T676): the label above
 * its value, with one optional act at the fact's right edge from the label's line
 * down. It draws a `div` holding a `dt` and a `dd`, so it stands inside a `dl`.
 * 🔨 Every `data-*` attribute the caller passes lands on the fact verbatim,
 * because a suite reads the fact by it.
 */
export interface FactProps extends RowDataAttributes {
  label: string;
  /** The value; a fact with several lines passes several elements. */
  children: ReactNode;
  /** The one act the fact carries, beside its label. */
  act?: ReactNode;
}

export function Fact({ label, children, act, ...data }: FactProps) {
  return (
    <div className={styles.fact} {...data}>
      <dt className={styles.label}>{label}</dt>
      <dd className={styles.value}>{children}</dd>
      {act ? <dd className={styles.act}>{act}</dd> : null}
    </div>
  );
}
